
import Vue from "vue"
import { extractHref, getInnerText } from "~/scripts/useful-functions"

export default Vue.extend({
  name: "AvWhatsappButton",
  props: {
    block: {
      type: Object as () => Block,
      required: true
    }
  },
  computed: {
    getLink(): string {
      return extractHref(this.block.innerBlocks[0].innerHtml) || ""
    },
    getButtonText(): string {
      return getInnerText(this.block.innerBlocks[0].innerHtml) || ""
    }
  },

  methods: {
    trackWhatsappBtnClick(): void {
      this.$snowplow.trackEvent({
        category: "contact_us",
        action: "click",
        property: "whatsapp"
      })
    }
  }
})
